module.exports = __webpack_public_path__ + "static/img/banner.fc01113.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner.jpg
// module id = hKcQ
// module chunks = 0